export var MOSTRAR_RELOJ = 'MOSTRAR_RELOJ';
export var mostrarReloj = function mostrarReloj() {
  return {
    type: MOSTRAR_RELOJ
  };
};
export var OCULTAR_RELOJ = 'OCULTAR_RELOJ';
export var ocultarReloj = function ocultarReloj() {
  return {
    type: OCULTAR_RELOJ
  };
};
export var MOVER_RELOJ = 'MOVER_RELOJ';
export var moverReloj = function moverReloj(x, y) {
  return {
    type: MOVER_RELOJ,
    x: x,
    y: y
  };
};